import { ref, onBeforeUnmount } from "vue";
import { useRouter } from "vue-router";


const STORAGE_KEYS = {
  START_TIME: 'startTime',
  CLOSED: 'closed',
}


export default function useUnregPush(delay = 5000, interval = 5000) {
  /**
   * delay - time in milliseconds until the push is hidden.
   * interval - period of check delay in milliseconds.
   */

  if (!sessionStorage.getItem(STORAGE_KEYS.START_TIME)) {
    sessionStorage.setItem(STORAGE_KEYS.START_TIME, Date.now());
    sessionStorage.setItem(STORAGE_KEYS.CLOSED, 0);
  }
  const enterTime = sessionStorage.getItem(STORAGE_KEYS.START_TIME);
  const isClosed = +sessionStorage.getItem(STORAGE_KEYS.CLOSED);

  var timer;

  const router = useRouter();
  const show = ref(false);

  onBeforeUnmount(() => {
    if (timer) {
      clearInterval(timer);
    }
  })

  function start(predicate = true) {
    if (!isClosed && predicate) {
      timer = setInterval(showHandler, interval);
    }
  }

  function showHandler() {
    const currentTime = Date.now();
    const spentTime = currentTime - enterTime;
    if (spentTime >= delay) {
      clearInterval(timer);
      show.value = true;
    }
  }

  function close() {
    show.value = false;
    sessionStorage.setItem(STORAGE_KEYS.CLOSED, 1);
    if (timer) {
      clearInterval(timer);
    }
  }

  function reg() {
    close();
    router.push({ name: 'register' });
  }

  function clearStorage() {
    // In case of sessionStorage this function is useless as all keys are destroyed after tab closing.
    for (const storageKey of Object.values(STORAGE_KEYS)) {
      sessionStorage.removeItem(storageKey);
    }
  }

  return {
    show,
    start,
    close,
    reg,
  }
}